import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { ChatBlackBG, CloseChatBlackBG } from '../../QPlayerSVGElement';
import { useChatLogin } from '../../../contexts/ChatLoginContext';

import './ChatToggle.scss';

const Container = styled.div`
	display: flex;
	justify-content: center;
	margin-left: auto;
	margin-right: auto;
	margin-bottom: 5px;
	pointer-events: all;
	height: 40px;
	width: 40px;
	align-items: center;
`;

const ChatToggle: React.FC = () => {
    const { showMobileChat, setShowMobileChat } = useChatLogin();
    const { t } = useTranslation();

    return (
        <Container
            tabIndex={-1}
            className="bottomControlbarChatToggle"
            role="button"
            aria-label={t(showMobileChat ? 'CHAT_WINDOW_CLOSE' : 'CHAT_WINDOW_OPEN')}
            onClick={() => setShowMobileChat(!showMobileChat)}
        >
            {showMobileChat ? <CloseChatBlackBG /> : <ChatBlackBG />}
        </Container>
    );
};

export default ChatToggle;
